import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';

import { QUERY_KEYS } from '@app/dashboard/constants/query-keys';
import {
  getMerchantFlags,
  updateMerchantFlags,
} from '@app/dashboard/services/inner_layout/flags';


const PASSWORD_KEY = 'password';
type TJsObject = Record<string, boolean | string | number>;


export const useMerchantFlags = (enabled = true) => {
  const queryClient = useQueryClient();

  const flagsQuery = useQuery({
    queryKey: [QUERY_KEYS.GET_FLAGS],
    queryFn: async () => {
      const res = await getMerchantFlags();
      return res.data?.options;
    },
    staleTime: Infinity,
    enabled
  });

  const flagMutation = useMutation({
    mutationFn: (payload: TJsObject) =>
      updateMerchantFlags(payload),
    onSettled: (_, __, variables) => {
      const formattedPayload = Object.entries(variables).map(([key, value]) => ({
        [key]: value
      }));

      const currentFlags: TJsObject[] = queryClient.getQueryData([QUERY_KEYS.GET_FLAGS]) || [];

      const cachedFlags = [...currentFlags, ...formattedPayload].reduce<TJsObject[]>((acc, item) => {
        const key = Object.keys(item)[0];
        if (key === PASSWORD_KEY) return acc;

        const idx = acc.findIndex(f => key in f);
        idx >= 0 ? acc.splice(idx, 1, item) : acc.push(item);
        return acc;
      }, []);

      queryClient.setQueryData([QUERY_KEYS.GET_FLAGS], cachedFlags);
    },
  });

  return { flagsQuery, flagMutation };
};
